(()=>{
  if(window.__WN_CART_CARE_DISCLOSURE_FIX_V2__) return;
  window.__WN_CART_CARE_DISCLOSURE_FIX_V2__=1;

  const lang=()=>String(document.documentElement.lang||'nl').toLowerCase().split('-')[0];
  const COPY={
    nl:{changeCare:'Filter Care wijzigen',changePlus:'Filter Care+ wijzigen',save:s=>s?`Bespaar ${s} met Care`:'Bespaar met Care',active:'Wijzig je Care-keuze of ga terug naar 6 filters eenmalig.',idle:'Optioneel. Je 6 filters staan al in je winkelwagen.'},
    en:{changeCare:'Change Filter Care',changePlus:'Change Filter Care+',save:s=>s?`Save ${s} with Care`:'Save with Care',active:'Change your Care option or switch back to 6 one-time filters.',idle:'Optional. Your 6 filters are already in the cart.'},
    de:{changeCare:'Filter Care ändern',changePlus:'Filter Care+ ändern',save:s=>s?`Spare ${s} mit Care`:'Mit Care sparen',active:'Ändere deine Care-Option oder wechsle zurück zu 6 Filtern als Einmalkauf.',idle:'Optional. Deine 6 Filter sind bereits im Warenkorb.'},
    fr:{changeCare:'Modifier Filter Care',changePlus:'Modifier Filter Care+',save:s=>s?`Économisez ${s} avec Care`:'Économisez avec Care',active:'Modifiez votre option Care ou revenez à 6 filtres en achat unique.',idle:'Facultatif. Vos 6 filtres sont déjà dans le panier.'},
    es:{changeCare:'Cambiar Filter Care',changePlus:'Cambiar Filter Care+',save:s=>s?`Ahorra ${s} con Care`:'Ahorra con Care',active:'Cambia tu opción Care o vuelve a 6 filtros en compra única.',idle:'Opcional. Tus 6 filtros ya están en el carrito.'},
    it:{changeCare:'Modifica Filter Care',changePlus:'Modifica Filter Care+',save:s=>s?`Risparmia ${s} con Care`:'Risparmia con Care',active:'Modifica la tua opzione Care o torna a 6 filtri con acquisto singolo.',idle:'Facoltativo. I tuoi 6 filtri sono già nel carrello.'}
  };
  const tr=()=>COPY[lang()]||COPY.en;
  const careState=details=>details.closest('[data-wn-care-state]')?.dataset.wnCareState||'starter';

  function savingFrom(copy,strong,small,details){
    if(details.dataset.wnCareSaving) return details.dataset.wnCareSaving;
    const raw=[
      copy.querySelector('[data-wn-care-saving-badge]')?.textContent||'',
      strong?.textContent||'',
      small?.textContent||''
    ].join(' ').replace(/\s+/g,' ').trim();
    const tail=raw.includes('·')?raw.split('·').pop().trim():raw;
    const money=tail.match(/(?:€|£|\$|CHF|EUR|USD|GBP)\s?\d+(?:[.,]\d{1,2})?|\d+(?:[.,]\d{1,2})?\s?(?:€|£|\$|CHF|EUR|USD|GBP)/i);
    const prefix=tail.match(/(?:bespaar|save|économisez|economisez|ahorra|risparmia)\s+(.+?)(?=\s+(?:vandaag|today|aujourd’hui|aujourd'hui|hoy|oggi|met|with|avec|con)\b|$)/i);
    const suffix=tail.match(/(.+?)\s+sparen\b/i);
    const saving=(money?.[0]||prefix?.[1]||suffix?.[1]||'').trim();
    if(saving) details.dataset.wnCareSaving=saving;
    return saving;
  }

  function enhance(scope=document){
    scope.querySelectorAll?.('[data-wn-cart-care-disclosure]').forEach(details=>{
      const summary=details.querySelector(':scope > .wn-cart-care-disclosure__summary');
      const copy=summary?.querySelector('.wn-cart-care-disclosure__copy');
      const strong=copy?.querySelector('strong');
      const small=copy?.querySelector('small');
      const helper=details.querySelector('.wn-cart-care-disclosure__helper');
      if(!summary||!copy||!strong) return;

      const saving=savingFrom(copy,strong,small,details);
      copy.querySelector('[data-wn-care-saving-badge]')?.remove();
      if(small){small.textContent='';small.hidden=true}

      const state=careState(details),t=tr();
      if(state==='care'){
        strong.textContent=t.changeCare;
      }else if(state==='plus'){
        strong.textContent=t.changePlus;
      }else{
        strong.textContent=t.save(saving);
      }

      if(helper){
        helper.textContent=(state==='care'||state==='plus')?t.active:t.idle;
      }

      summary.setAttribute('aria-expanded',details.open?'true':'false');
    });
  }

  window.addEventListener('click',event=>{
    const target=event.target instanceof Element?event.target:null;

    /* The simplified cart nests the existing V18 Care cards inside <details>.
       V18 intentionally ignores card clicks that have a <details> ancestor, so
       bridge an unchecked card back to V18's original change handler here. */
    const option=target?.closest('[data-wn-cart-care-disclosure] [data-care-option]');
    if(option&&!target.closest('a,button,summary')){
      const input=option.querySelector('[data-wn-care-toggle]');
      if(input&&!input.disabled&&!input.checked){
        event.preventDefault();
        input.checked=true;
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }
      return;
    }

    const summary=target?.closest('[data-wn-cart-care-disclosure] > .wn-cart-care-disclosure__summary');
    if(!summary) return;
    const details=summary.closest('[data-wn-cart-care-disclosure]');
    if(!details) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    details.open=!details.open;
    summary.setAttribute('aria-expanded',details.open?'true':'false');
    if(typeof summary.focus==='function') summary.focus({preventScroll:true});
  },true);

  const queue=()=>requestAnimationFrame(()=>enhance(document));
  document.addEventListener('wn:cart:updated',queue);
  document.addEventListener('shopify:section:load',queue);

  const start=()=>{
    enhance(document);
    if(!document.body) return;
    new MutationObserver(mutations=>{
      if(mutations.some(m=>[...m.addedNodes].some(node=>node?.nodeType===1))) queue();
    }).observe(document.body,{childList:true,subtree:true});
  };

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
